export enum StatisticItemTypeEnum {
    athletes = "ATHLETES",
    clubs = "CLUBS"
}
